export default __webpack_public_path__ + "static/media/img-ltsh-8-1.2573b951.png";